// extracted by mini-css-extract-plugin
module.exports = {"templateWrapper":"styles_templateWrapper__pefQw","mainWrapper":"styles_mainWrapper__1FH-p","content":"styles_content__3KioZ"};